import { motion } from "motion/react";

export const MainAvelaAnimation = () => {
  const letterPathVariants = {
    rest: {
      scale: 1,
      filter: "drop-shadow(0px 0px 0px rgba(255, 255, 255, 0))",
    },
    lift: {
      scale: 1.01,
      filter: "drop-shadow(0px 0px 8px rgba(255, 255, 255, 0.3))",
    },
  };

  const letterTransition = {
    scale: {
      type: "spring" as const,
      stiffness: 520,
      damping: 24,
      mass: 0.45,
    },
    filter: {
      type: "tween" as const,
      duration: 0.22,
      ease: [0.25, 0.4, 0.25, 1] as const,
    },
  };

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1620"
      height="480"
      viewBox="0 0 1620 470"
      fill="none"
    >
      <defs>
        <filter id="glow-rest" x="-50%" y="-50%" width="200%" height="200%">
          <feDropShadow dx="0" dy="0" stdDeviation="0" floodColor="white" floodOpacity="0"/>
        </filter>
        <filter id="glow-hover" x="-50%" y="-50%" width="200%" height="200%">
          <feDropShadow dx="0" dy="0" stdDeviation="4" floodColor="white" floodOpacity="0.3"/>
        </filter>

        <linearGradient
          id="paint0_linear_40000330_4497"
          x1="810.134"
          y1="-799.904"
          x2="810.134"
          y2="457.632"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0.6" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_40000330_4497"
          x1="810.134"
          y1="-799.904"
          x2="810.134"
          y2="457.632"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0.6" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_40000330_4497"
          x1="810.134"
          y1="-799.904"
          x2="810.134"
          y2="457.632"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0.6" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_40000330_4497"
          x1="810.134"
          y1="-799.904"
          x2="810.134"
          y2="457.632"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0.6" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_40000330_4497"
          x1="810.134"
          y1="-799.904"
          x2="810.134"
          y2="457.632"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0.6" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
      </defs>

      <motion.g whileHover="lift" initial="rest">
        <rect
          x="1000"
          y="-20"
          width="230"
          height="510"
          fill="transparent"
          pointerEvents="all"
        />
        <motion.path
          variants={letterPathVariants}
          transition={letterTransition}
          d="M1190.88 0C1180.36 32.9952 1174.86 109.745 1174.38 230.249C1173.9 350.275 1179.41 427.025 1190.88 460.499H1028.74C1042.61 427.025 1049.55 357.448 1049.55 251.768C1049.55 146.088 1042.61 78.6625 1028.74 49.4929C1045.48 47.1019 1064.14 43.5155 1084.7 38.7335C1105.75 33.4734 1125.84 27.496 1144.97 20.8013C1164.1 13.6285 1179.41 6.69468 1190.88 0Z"
          fill="url(#paint0_linear_40000330_4497)"
        />
      </motion.g>

      <motion.g whileHover="lift" initial="rest">
        <rect
          x="1170"
          y="70"
          width="470"
          height="430"
          fill="transparent"
          pointerEvents="all"
        />
        <motion.path
          variants={letterPathVariants}
          transition={letterTransition}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1399.71 347.882C1394.93 364.619 1389.91 379.204 1384.64 391.637C1379.86 403.592 1373.16 416.025 1364.56 428.936C1356.42 441.847 1345.9 451.889 1332.99 459.062C1320.55 465.757 1305.96 469.104 1289.22 469.104C1262.44 469.104 1241.16 459.779 1225.37 441.13C1210.07 422.002 1203.13 399.527 1204.57 373.705C1206.48 347.404 1216.76 324.69 1235.42 305.562C1248.81 291.695 1265.55 279.74 1285.64 269.698C1305.73 259.178 1323.42 251.527 1338.73 246.745C1354.51 241.963 1369.1 234.79 1382.49 225.226C1396.36 215.184 1405.21 202.512 1409.04 187.21C1412.86 171.43 1412.15 156.845 1406.88 143.455C1402.1 129.588 1391.58 121.937 1375.32 120.502C1367.19 120.024 1359.06 122.176 1350.92 126.958C1343.27 131.74 1337.29 137.956 1332.99 145.607C1329.16 152.78 1328.44 161.866 1330.84 172.864C1333.23 183.384 1339.68 193.905 1350.21 204.425C1340.16 216.858 1326.53 225.226 1309.31 229.53C1292.09 233.356 1275.59 231.443 1259.81 223.792C1244.5 216.141 1234.7 203.229 1230.39 185.058C1227.05 159.236 1242.59 137 1277.03 118.35C1314.81 98.2663 1356.66 91.3326 1402.58 97.5491C1457.58 104.244 1494.65 128.871 1513.78 171.43C1521.91 189.601 1525.98 210.402 1525.98 233.834L1526.7 365.815C1526.7 391.159 1529.09 410.286 1533.87 423.198C1538.66 436.109 1546.31 441.608 1556.83 439.695C1570.7 434.913 1575.96 418.894 1572.61 391.637C1569.74 363.902 1560.42 340.71 1544.63 322.06C1571.9 308.193 1592.94 311.54 1607.77 332.102C1620.68 351.23 1622.6 374.183 1613.51 400.962C1602.99 433.001 1580.51 453.563 1546.07 462.648C1535.07 465.996 1523.11 467.67 1510.2 467.67C1437.5 467.67 1400.67 427.741 1399.71 347.882ZM1399.71 288.348C1400.19 268.264 1400.43 253.918 1400.43 245.31C1399.47 245.789 1396.84 248.179 1392.54 252.483C1388.71 256.787 1386.08 259.656 1384.64 261.091C1383.69 262.047 1381.3 264.677 1377.47 268.981C1374.12 272.806 1371.73 275.915 1370.3 278.306C1368.86 280.218 1366.47 283.327 1363.12 287.63C1359.77 291.456 1357.38 294.803 1355.95 297.672L1350.21 309.149C1347.82 313.453 1345.9 317.517 1344.47 321.343C1343.03 325.168 1341.6 329.472 1340.16 334.254L1337.29 348.6C1335.38 360.076 1335.62 369.162 1338.01 375.857C1340.4 382.551 1344.23 385.899 1349.49 385.899C1360.01 384.942 1369.1 376.096 1376.75 359.359C1384.88 342.144 1392.54 318.474 1399.71 288.348Z"
          fill="url(#paint1_linear_40000330_4497)"
        />
      </motion.g>

      <motion.g whileHover="lift" initial="rest">
        <rect
          x="650"
          y="80"
          width="400"
          height="420"
          fill="transparent"
          pointerEvents="all"
        />
        <motion.path
          variants={letterPathVariants}
          transition={letterTransition}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1004.75 374.421C1009.53 363.422 1012.64 351.946 1014.07 339.991C976.288 354.337 941.611 358.88 910.044 353.619C878.476 348.359 851.692 337.839 829.69 322.059C808.167 305.8 791.426 285.955 779.469 262.524H1016.23C1012.4 217.096 994.941 179.079 963.852 148.475C932.763 117.871 895.695 102.569 852.648 102.569C824.907 102.569 799.318 109.024 775.882 121.935C752.445 134.368 733.553 150.866 719.204 171.428C705.333 191.512 695.289 214.466 689.071 240.288C682.853 265.632 681.179 290.737 684.049 315.603C687.397 340.469 696.006 364.618 709.877 388.049C724.226 411.002 743.358 429.652 767.273 443.998C808.884 469.342 853.605 475.558 901.435 462.647C913.392 459.3 924.632 454.757 935.154 449.019C946.155 443.28 955.96 436.586 964.57 428.935C973.657 421.284 981.549 412.915 988.245 403.83C994.941 394.744 1000.44 384.941 1004.75 374.421ZM755.793 176.449C756.75 159.713 761.772 150.388 770.86 148.475C784.73 145.606 801.71 153.257 821.798 171.428C841.887 189.6 856.475 211.836 865.562 238.136H768.707C759.142 213.27 754.837 192.708 755.793 176.449Z"
          fill="url(#paint2_linear_40000330_4497)"
        />
      </motion.g>

      <motion.g whileHover="lift" initial="rest">
        <rect
          x="330"
          y="80"
          width="380"
          height="420"
          fill="transparent"
          pointerEvents="all"
        />
        <motion.path
          variants={letterPathVariants}
          transition={letterTransition}
          d="M545.637 322.777C548.985 336.166 553.05 347.404 557.833 356.489C562.616 365.575 567.878 372.03 573.617 375.856C579.357 379.203 585.575 378.008 592.271 372.27C598.967 366.053 604.946 354.816 610.207 338.557C625.034 295.998 633.165 256.069 634.6 218.77C635.078 191.035 632.926 168.321 628.143 150.628C623.36 132.935 614.033 118.35 600.163 106.873C618.816 96.3529 634.6 94.6793 647.514 101.852C660.906 109.025 668.798 121.458 671.19 139.151C675.016 168.799 666.167 224.508 644.644 306.279C623.599 387.572 603.989 435.63 585.814 450.454C575.77 459.061 563.812 465.039 549.942 468.386C536.071 471.255 521.244 470.299 505.46 465.517C490.155 460.735 477.48 450.932 467.436 436.108C456.913 419.85 445.195 386.854 432.281 337.122C419.367 287.391 406.692 239.571 394.256 193.665C381.82 147.28 370.102 118.589 359.101 107.59H528.418C521.244 116.198 517.178 131.739 516.222 154.214C515.265 176.211 517.657 200.36 523.396 226.66L545.637 322.777Z"
          fill="url(#paint3_linear_40000330_4497)"
        />
      </motion.g>

      <motion.g whileHover="lift" initial="rest">
        <rect
          x="-30"
          y="80"
          width="480"
          height="420"
          fill="transparent"
          pointerEvents="all"
        />
        <motion.path
          variants={letterPathVariants}
          transition={letterTransition}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M180.263 391.637C185.524 379.204 190.546 364.619 195.329 347.882C196.286 427.741 233.115 467.67 305.816 467.67C318.73 467.67 330.687 465.996 341.688 462.648C376.125 453.563 398.605 433.001 409.127 400.962C418.215 374.183 416.302 351.23 403.388 332.102C388.561 311.54 367.516 308.193 340.253 322.06C356.037 340.71 365.363 363.902 368.233 391.637C371.581 418.894 366.32 434.913 352.449 439.695C341.927 441.608 334.274 436.109 329.491 423.198C324.708 410.286 322.317 391.159 322.317 365.815L321.599 233.834C321.599 210.402 317.534 189.601 309.403 171.43C290.271 128.871 253.203 104.244 198.199 97.5491C152.283 91.3326 110.432 98.2663 72.6463 118.35C38.209 137 22.6644 159.236 26.0125 185.058C30.3171 203.229 40.1222 216.141 55.4277 223.792C71.2114 231.443 87.7127 233.356 104.931 229.53C122.15 225.226 135.781 216.858 145.826 204.425C135.303 193.905 128.846 183.384 126.455 172.864C124.063 161.866 124.781 152.78 128.607 145.607C132.912 137.956 138.89 131.74 146.543 126.958C154.674 122.176 162.805 120.024 170.936 120.502C187.198 121.937 197.721 129.588 202.504 143.455C207.765 156.845 208.482 171.43 204.656 187.21C200.83 202.512 191.981 215.184 178.111 225.226C164.718 234.79 150.13 241.963 134.347 246.745C119.041 251.527 101.344 259.178 81.2556 269.698C61.1672 279.74 44.4269 291.695 31.0346 305.562C12.381 324.69 2.09767 347.404 0.184486 373.705C-1.2504 399.527 5.68489 422.002 20.9904 441.13C36.7741 459.779 58.0583 469.104 84.8429 469.104C101.583 469.104 116.171 465.757 128.607 459.062C141.521 451.889 152.043 441.847 160.174 428.936C168.784 416.025 175.48 403.592 180.263 391.637ZM196.047 245.31C196.047 253.918 195.808 268.264 195.329 288.348C188.155 318.474 180.502 342.144 172.371 359.359C164.718 376.096 155.631 384.942 145.108 385.899C139.847 385.899 136.021 382.551 133.629 375.857C131.238 369.162 130.998 360.076 132.912 348.6L135.781 334.254C137.216 329.472 138.651 325.168 140.086 321.343C141.521 317.517 143.434 313.453 145.826 309.149L151.565 297.672C153 294.803 155.392 291.456 158.74 287.63C162.088 283.327 164.479 280.218 165.914 278.306C167.349 275.915 169.74 272.806 173.088 268.981C176.915 264.677 179.306 262.047 180.263 261.091C181.698 259.656 184.328 256.787 188.155 252.483C192.459 248.179 195.09 245.789 196.047 245.31Z"
          fill="url(#paint4_linear_40000330_4497)"
        />
      </motion.g>
    </svg>
  );
};